<template>
  <div class="content-wrapper">
    <p class="title">{{ $t('app.panels.addMember.consultant.title') }} {{ $t('other.form.optional') }}</p>
    <MemberEmailSelect input-class="sm xs-text" v-model="emailModel" :members="memberDetails" @change="changeEmail"></MemberEmailSelect>
    <div v-if="!props.modelValue.memberDetails" class="inline">
      <VField class="sm xs-text" name="firstName" v-model="firstNameModel" :label="$t('other.form.firstName')" placeholder="Vanessa"></VField>
      <VField class="sm xs-text" name="lastName" v-model="lastNameModel" :label="$t('other.form.lastName')" placeholder="Denfer"></VField>
    </div>
  </div>
</template>

<script setup lang="ts">
import VField from '@/components/global/VField.vue';
import MemberEmailSelect from '@/components/input/MemberEmailSelect.vue';

import { useMembersDetails } from '@/queries/members.query';
import { MemberDetails } from '@/types/member';

const { data: memberDetails } = useMembersDetails();

const emit = defineEmits<{
  (e: 'update:modelValue', value: { email: string, firstName: string, lastName: string }): void
  (e: 'valid', value: boolean): void,
}>();

const props = defineProps<{
  modelValue: { email: string, firstName: string, lastName: string, memberDetails?: MemberDetails },
}>();

const emailModel = computed({
  get: () => props.modelValue.email,
  set: (value: string) => {
    props.modelValue.email = value;
    emit('valid', true);
    emit('update:modelValue', props.modelValue);
  }
});

function changeEmail(p: { email: string, member?: MemberDetails }) {
  if (p?.member) {
    props.modelValue.memberDetails = p.member;
    emit('valid', true);
    emit('update:modelValue', props.modelValue);
  } else {
    props.modelValue.memberDetails = undefined;
  }
}

const firstNameModel = computed({
  get: () => props.modelValue.firstName,
  set: (value: string) => {
    props.modelValue.firstName = value;
    emit('valid', true);
    emit('update:modelValue', props.modelValue);
  }
});

const lastNameModel = computed({
  get: () => props.modelValue.lastName,
  set: (value: string) => {
    props.modelValue.lastName = value;
    emit('valid', true);
    emit('update:modelValue', props.modelValue);
  }
});
</script>

<style lang="scss" scoped>
@import "@/assets/style/variables.scss";

.content-wrapper {
  display: flex;
  flex-direction: column;
  gap: 20px;

  .title {
    font-size: 16px;
    font-weight: 700;
  }

  .edit-buttons {
    display: flex;
    align-items: center;
    justify-content: start;
    gap: 10px;
  }

  .inline {
    display: flex;
    gap: 8px;
    
    .input-wrapper {
      flex: 1;
    }
  }
}
</style>